import { all } from "redux-saga/effects";
import authSagas from "./auth/saga";
import athleteSagas from "./athletes/saga";
import programmingSagas from "./programming/saga";
import exerciseSagas from "./exercises/saga";
import activeprogramSagas from "./activeprogram/saga";

export default function* rootSaga(getState) {
	yield all([
		authSagas(),
		athleteSagas(),
		programmingSagas(),
		exerciseSagas(),
		activeprogramSagas()
	]);
}
